import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    title: "",
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        changeFilter: (state, action) => {
            state.title = action.payload;
        },
    },
});

export const { changeFilter } = filterSlice.actions;
export default filterSlice.reducer;
